function getContent(content) {
    if (typeof (content) !== 'string') {
        return null;
    }

    return content;
}

function getAttributes(content, attributes) {

    if (typeof (content) !== 'string') {
        return Object.entries(content);
    }

    return Object.entries(attributes);
}

export const generate = (tagName, content, attributes) => {
    const elem = document.createElement(tagName);
    const elemContent = getContent(content);
    const elemAttrs = getAttributes(content, attributes);

    elemAttrs.forEach((attrGroup) => {
        elem.setAttribute(attrGroup[0], attrGroup[1]);
    });

    if (elemContent !== null) {
        elem.innerHTML = elemContent;
    }

    return elem;
}